import { BORDER_RADIUS, COLORS, SIZE } from "constants/variables";
import styled, { css } from "styled-components";
import { CardType } from "./ContactModel";

export const ContactContainer = styled.div`
  padding-block: calc(100px + ${SIZE.max80}) 0;
  padding-inline: ${SIZE.max220};

  @media (max-width: 900px) {
    padding-inline: ${SIZE.max80};
  }
`;

export const ContactWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: ${SIZE.max24};

  @media (max-width: 1228px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const ContactCardWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  border-radius: ${BORDER_RADIUS.radius32};
  background-color: ${COLORS.Cultured};
  grid-area: 1 / 1 / 3 / 4;

  @media (max-width: 1228px) {
    grid-area: 1 / 1 / 3 / 3;
  }

  @media (max-width: 900px) {
    flex-direction: column-reverse;
  }

  @media (max-width: 768px) {
    grid-area: 1 / 1 / 3 / 2;
  }
`;

export const ContactCardTextContainer = styled.div`
  padding: ${SIZE.max80};
  display: flex;
  flex-direction: column;
  gap: ${SIZE.max8};
`;

export const ContactCardTtileWrapper = styled.div``;

export const ContactCardSubtitleWrapper = styled.div``;

export const ContactCardTextWrapper = styled.div`
  padding-block: ${SIZE.max16} 0;
`;

export const ContactCardIconWrapper = styled.div`
  margin: 0 ${SIZE.max140} 0 0;
  align-self: center;

  @media (max-width: 900px) {
    margin: 0;
  }
`;

export const ContactCardIcon = styled.img`
  height: ${SIZE.max360};
`;

export const ContactInfoCardWrapper = styled.div<{ type: CardType }>`
  width: 100%;
  height: 100%;
  height: ${SIZE.max224};
  background-color: ${COLORS.VividAuburn};
  border-radius: ${BORDER_RADIUS.radius24};
  padding: ${SIZE.max40} ${SIZE.max32} ${SIZE.max32} ${SIZE.max40};
  display: flex;
  justify-content: space-between;

  ${({ type }) =>
    type === CardType.PHONE &&
    css`
      grid-area: 3 / 1 / 4 / 2;

      @media (max-width: 1228px) {
        grid-area: 3 / 1 / 4 / 2;
      }

      @media (max-width: 768px) {
        grid-area: 3 / 1 / 4 / 2;
      }
    `}
  ${({ type }) =>
    type === CardType.CENTER &&
    css`
      grid-area: 3 / 2 / 4 / 3;

      @media (max-width: 1228px) {
        grid-area: 3 / 2 / 4 / 3;
      }

      @media (max-width: 768px) {
        grid-area: 4 / 1 / 5 / 2;
      }
    `}
  ${({ type }) =>
    type === CardType.EMAIL &&
    css`
      grid-area: 3 / 3 / 4 / 4;

      @media (max-width: 1228px) {
        grid-area: 4 / 1 / 5 / 2;
      }

      @media (max-width: 768px) {
        grid-area: 5/1/6/2;
      }
    `}
  ${({ type }) =>
    type === CardType.FAX &&
    css`
      grid-area: 4 / 3 / 5 / 4;

      @media (max-width: 1228px) {
        grid-area: 4 / 2 / 5 / 3;
      }

      @media (max-width: 768px) {
        grid-area: 6 / 1 / 7 / 2;
      }
    `}
`;

export const ContactInfoCardTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SIZE.max28};
`;

export const ContactInfoCardTitleWrapper = styled.div``;

export const ContactInfoCardValueWrapper = styled.div``;

export const ContactInfoCardIconWrapper = styled.div`
  align-self: flex-end;
`;

export const ContactInfoCardIcon = styled.img`
  height: ${SIZE.max80};

  @media (max-width: 1228px) {
    height: ${SIZE.max100};
  }

  @media (max-width: 768px) {
    height: ${SIZE.fix64};
  }
`;

export const ContactMapCardWrapper = styled.div`
  width: 100%;
  height: 100%;
  height: ${SIZE.max224};
  grid-area: 4 / 1 / 5 / 3;
  border-radius: ${BORDER_RADIUS.radius24};

  position: relative;

  @media (max-width: 1228px) {
    grid-area: 5 / 1 / 6 / 3;
  }

  @media (max-width: 768px) {
    grid-area: 7 / 1 / 9 / 2;
    height: ${SIZE.max380};
  }
`;

export const ContactMapOverlay = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 5;
  background-color: ${COLORS.RaisinBlack}A3;
  border-radius: ${BORDER_RADIUS.radius24};
  transition: background 0.3s ease-in-out;
  inset: 0;
  padding: ${SIZE.max40};
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  row-gap: ${SIZE.max10};
  cursor: pointer;

  :hover {
    background-color: ${COLORS.RaisinBlack}52;
  }
`;
